/* Manager tour — 7 steps. Team / approvals focused. */
export default {
  role: "MANAGER",
  steps: [
    {
      id: "mgr-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.mgr.welcome.title", titleFallback: "Welcome, {name}",
      bodyKey: "tour.mgr.welcome.body", bodyFallback: "Quick tour of your team's surface — pipeline, approvals, attendance, performance.",
      side: "bottom",
    },
    {
      id: "mgr-team-pipeline",
      route: "/sales/pipeline",
      selector: '[data-tour-id="sales-pipeline"]',
      titleKey: "tour.mgr.pipeline.title", titleFallback: "Team pipeline",
      bodyKey: "tour.mgr.pipeline.body", bodyFallback: "You see every rep reporting to you. Filter by owner to coach 1:1s.",
      side: "top",
    },
    {
      id: "mgr-approvals",
      route: "/hr/approvals",
      selector: '[data-tour-id="approvals-page"]',
      titleKey: "tour.mgr.approvals.title", titleFallback: "Approvals queue",
      bodyKey: "tour.mgr.approvals.body", bodyFallback: "Leave + expense + regularisation — your sign-offs. Bulk-approve safe categories in one click.",
      side: "top",
      optional: true,
    },
    {
      id: "mgr-attendance",
      route: "/hr/attendance",
      selector: '[data-tour-id="attendance-page"]',
      titleKey: "tour.mgr.attendance.title", titleFallback: "Team attendance",
      bodyKey: "tour.mgr.attendance.body", bodyFallback: "Who's in, who's out, who's roaming. Geofence enforced.",
      side: "top",
      optional: true,
    },
    {
      id: "mgr-leave-cal",
      route: "/hr/leave",
      selector: '[data-tour-id="leave-page"]',
      titleKey: "tour.mgr.leaveCal.title", titleFallback: "Leave calendar",
      bodyKey: "tour.mgr.leaveCal.body", bodyFallback: "Plan coverage. See who's on chutti when.",
      side: "top",
      optional: true,
    },
    {
      id: "mgr-perf",
      route: "/sales/reports",
      selector: '[data-tour-id="reports-page"]',
      titleKey: "tour.mgr.perf.title", titleFallback: "Performance dashboard",
      bodyKey: "tour.mgr.perf.body", bodyFallback: "Target attainment, conversion funnel, top performers — drill by rep.",
      side: "top",
      optional: true,
    },
    {
      id: "mgr-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.mgr.replay.title", titleFallback: "Replay anytime",
      bodyKey: "tour.mgr.replay.body", bodyFallback: "Always available in the header.",
      side: "bottom",
    },
  ],
};
